/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 乗務員毎週次乗務
 * @export
 * @interface WeeklyDriverShiftsRow
 */
export interface WeeklyDriverShiftsRow {
    /**
     * 乗務員ID
     * @type {number}
     * @memberof WeeklyDriverShiftsRow
     */
    driverId?: number;
    /**
     * 乗務員名
     * @type {string}
     * @memberof WeeklyDriverShiftsRow
     */
    driverName?: string;
    /**
     * 乗務員番号
     * @type {string}
     * @memberof WeeklyDriverShiftsRow
     */
    driverCode?: string;
    /**
     * 改善コメント
     * @type {string}
     * @memberof WeeklyDriverShiftsRow
     */
    instructionMessage?: string;
    /**
     * (改善コメントのID)
     * @type {number}
     * @memberof WeeklyDriverShiftsRow
     */
    instructionId?: number;
    /**
     * (改善コメントの優先順位)
     * @type {number}
     * @memberof WeeklyDriverShiftsRow
     */
    instructionPriority?: number;
    /**
     * (営業所ID)
     * @type {number}
     * @memberof WeeklyDriverShiftsRow
     */
    officeId?: number;
    /**
     * 複数のログイン/ログアウトを乗務単位にまとめるためのID
     * @type {string}
     * @memberof WeeklyDriverShiftsRow
     */
    shiftId?: string;
    /**
     * 実車回数
     * @type {number}
     * @memberof WeeklyDriverShiftsRow
     */
    numTrips?: number;
    /**
     * 営収
     * @type {number}
     * @memberof WeeklyDriverShiftsRow
     */
    totalShiftRevenue?: number;
    /**
     * 営業所平均
     * @type {number}
     * @memberof WeeklyDriverShiftsRow
     */
    officeTotalAmountPerShift?: number;
    /**
     * ナビ利用率
     * @type {number}
     * @memberof WeeklyDriverShiftsRow
     */
    hermesUsingRate?: number;
    /**
     * 乗務時間
     * @type {number}
     * @memberof WeeklyDriverShiftsRow
     */
    shiftMin?: number;
    /**
     * 停車時間
     * @type {number}
     * @memberof WeeklyDriverShiftsRow
     */
    breakMin?: number;
    /**
     * 日付
     * @type {string}
     * @memberof WeeklyDriverShiftsRow
     */
    shiftStartDt?: string;
    /**
     * (乗務種別)
     * @type {string}
     * @memberof WeeklyDriverShiftsRow
     */
    shiftType?: string;
    /**
     * (worst trip)
     * @type {string}
     * @memberof WeeklyDriverShiftsRow
     */
    worstUnladenTripSessionId?: string;
    /**
     * (worst trip TS)
     * @type {string}
     * @memberof WeeklyDriverShiftsRow
     */
    worstUnladenStartTs?: string;
}

export function WeeklyDriverShiftsRowFromJSON(json: any): WeeklyDriverShiftsRow {
    return WeeklyDriverShiftsRowFromJSONTyped(json, false);
}

export function WeeklyDriverShiftsRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeeklyDriverShiftsRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'driverId': !exists(json, 'driver_id') ? undefined : json['driver_id'],
        'driverName': !exists(json, 'driver_name') ? undefined : json['driver_name'],
        'driverCode': !exists(json, 'driver_code') ? undefined : json['driver_code'],
        'instructionMessage': !exists(json, 'instruction_message') ? undefined : json['instruction_message'],
        'instructionId': !exists(json, 'instruction_id') ? undefined : json['instruction_id'],
        'instructionPriority': !exists(json, 'instruction_priority') ? undefined : json['instruction_priority'],
        'officeId': !exists(json, 'office_id') ? undefined : json['office_id'],
        'shiftId': !exists(json, 'shift_id') ? undefined : json['shift_id'],
        'numTrips': !exists(json, 'num_trips') ? undefined : json['num_trips'],
        'totalShiftRevenue': !exists(json, 'total_shift_revenue') ? undefined : json['total_shift_revenue'],
        'officeTotalAmountPerShift': !exists(json, 'office_total_amount_per_shift') ? undefined : json['office_total_amount_per_shift'],
        'hermesUsingRate': !exists(json, 'hermes_using_rate') ? undefined : json['hermes_using_rate'],
        'shiftMin': !exists(json, 'shift_min') ? undefined : json['shift_min'],
        'breakMin': !exists(json, 'break_min') ? undefined : json['break_min'],
        'shiftStartDt': !exists(json, 'shift_start_dt') ? undefined : json['shift_start_dt'],
        'shiftType': !exists(json, 'shift_type') ? undefined : json['shift_type'],
        'worstUnladenTripSessionId': !exists(json, 'worst_unladen_trip_session_id') ? undefined : json['worst_unladen_trip_session_id'],
        'worstUnladenStartTs': !exists(json, 'worst_unladen_start_ts') ? undefined : json['worst_unladen_start_ts'],
    };
}

export function WeeklyDriverShiftsRowToJSON(value?: WeeklyDriverShiftsRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'driver_id': value.driverId,
        'driver_name': value.driverName,
        'driver_code': value.driverCode,
        'instruction_message': value.instructionMessage,
        'instruction_id': value.instructionId,
        'instruction_priority': value.instructionPriority,
        'office_id': value.officeId,
        'shift_id': value.shiftId,
        'num_trips': value.numTrips,
        'total_shift_revenue': value.totalShiftRevenue,
        'office_total_amount_per_shift': value.officeTotalAmountPerShift,
        'hermes_using_rate': value.hermesUsingRate,
        'shift_min': value.shiftMin,
        'break_min': value.breakMin,
        'shift_start_dt': value.shiftStartDt,
        'shift_type': value.shiftType,
        'worst_unladen_trip_session_id': value.worstUnladenTripSessionId,
        'worst_unladen_start_ts': value.worstUnladenStartTs,
    };
}


